import $ from 'jquery';
import core from '../core';

let $window = null;
let $headerEl = null;

function handleStickyPageHeader() {
    if (!$headerEl) return;

    const scrollTop = $window.scrollTop();

    if (scrollTop <= 0) {
        $headerEl.removeClass('header--filled');
    } else {
        $headerEl.addClass('header--filled');
    }
}

function setup() {
    $window = $(window);
    $headerEl = $('.js-header:not(.header--filled)');

    handleStickyPageHeader();
}

function handleRaf() {
    handleStickyPageHeader();
}

core.Component('page-header', {
    methods: {
        _raf: handleRaf,
    }
});

core.Ready(setup);
